module.exports = __webpack_public_path__ + "static/media/file-jpg.a09d35e5.svg";